export default __webpack_public_path__ + "static/media/broadcastcard.b63c4e67.svg";